import clsx from "classnames";
import classes from "./styles.module.scss";
import OfficeCard from "@/components/OfficeCard";
import HeaderTitle from "@/components/HeaderTitle";

export default function OfficeCarousel({ offices, className }) {

  return (
    <div className={clsx(className, classes.carousel_cont)}>
      <div className={classes.title}><HeaderTitle tag="h2" title="our offices"/></div>
      <div className={classes.carousel}>
        {offices?.map((office, index) => (
          <OfficeCard key={index} office={{office}} />
        ))}
      </div>
    </div>
  );
}

OfficeCarousel.defaultProps = {
  className: "",
};
